import { ClaimTypeCode } from './claim';

/**
 * @deprecated functionality has been replaced by `ClinicalImpression`
 *
 * To be used for the `class.code` of an Encounter
 */
export enum EncounterCode {
  note = 'encounter.note',
  admission = 'encounter.admission',
  automatic = 'encounter.automatic',
  summary = 'encounter.summary',
  discharge = 'encounter.discharge',
}

/**
 * @deprecated functionality has been replaced by `ClinicalImpression`
 *
 * To be used for the `type`
 */
export enum EncounterType {
  patch = 'encounter.type.patch',
  relay = 'encounter.type.relay',
  onboarding = 'encounter.type.onboarding',
  homeVisit = 'encounter.type.homevisit',
  virtualVisit = 'encounter.type.virtualvisit',
  clinicalCallout = 'encounter.type.clinicalcallout',
  clinicalUpdate = 'encounter.type.clinicalupdate',
  welcomeUpdate = 'encounter.type.welcome',
  dischargeUpdate = 'encounter.type.discharge',
  bloodResults = 'encounter.type.bloodresults',
  physiotherapy = 'encounter.type.physiotherapy',
}

/**
 * @deprecated functionality has been replaced by `ClinicalImpression`
 *
 * To be used for Encounter.Participant[x].type
 */
export enum EncounterParticipantType {
  /**
   * Participant that created the `Encounter`
   */
  CreatorPractitioner = 'encounterparticipant.creator',
  /**
   * Participant listed to receive a notification for the `Encounter`
   */
  NotifyPractitioner = 'encounterparticipant.notify',
}

/**
 * High level classification for encounter
 */
export enum EncounterClass {
  Home = 'encounter.class.home',
  Hospital = 'encounter.class.hospital',
}

/**
 * The service code that the encounter is associated with
 * The `CareAtHome` service has been removed for now because it currently not used
 */
export enum EncounterService {
  Arthroplasty = 'encounter.service.arthroplasty',
  HealingHands = 'encounter.service.healinghands',
  HospitalAtHome = 'encounter.service.hospitalathome',
  HospitalAtHomeUpgrade = 'encounter.service.hospitalathome.upgrade',
  InHospitalMonitoring = 'encounter.service.inhospitalmonitoring',
  RemotePatientMonitoring = 'encounter.service.remotepatientmonitoring',
  TCP = 'encounter.service.tcp',
  SPHERE = 'encounter.service.sphere',
}

export const encounterServiceDisplay: Record<EncounterService, string> = {
  [EncounterService.HospitalAtHome]: 'Hospital at Home',
  [EncounterService.TCP]: 'TCP',
  [EncounterService.RemotePatientMonitoring]: 'Remote Patient Monitoring',
  [EncounterService.HealingHands]: 'Healing Hands',
  [EncounterService.Arthroplasty]: 'Arthroplasty',
  [EncounterService.InHospitalMonitoring]: 'In-Hospital Monitoring',
  [EncounterService.HospitalAtHomeUpgrade]: 'Hospital at Home Upgrade',
  [EncounterService.SPHERE]: 'Quro SPHERE',
};

export const encounterServiceClaimTypeMap: Record<
  EncounterService,
  ClaimTypeCode
> = {
  [EncounterService.HospitalAtHome]: ClaimTypeCode.HospitalAtHome,
  [EncounterService.TCP]: ClaimTypeCode.TCP,
  [EncounterService.RemotePatientMonitoring]:
    ClaimTypeCode.RemotePatientMonitoring,
  [EncounterService.HealingHands]: ClaimTypeCode.HealingHands,
  [EncounterService.Arthroplasty]: ClaimTypeCode.Arthroplasty,
  [EncounterService.InHospitalMonitoring]: ClaimTypeCode.InHospitalMonitoring,
  [EncounterService.HospitalAtHomeUpgrade]: ClaimTypeCode.HospitalAtHomeUpgrade,
  [EncounterService.SPHERE]: ClaimTypeCode.SPHERE,
};

export enum EncounterDischargeReasonCode {
  Completed = 'encounter.reasonCode.discharge.completed',
  Demised = 'encounter.reasonCode.discharge.demised',
  RevokeConsent = 'encounter.reasonCode.discharge.revokeconsent',
  Transfer = 'encounter.reasonCode.discharge.transfer',
  Upgrade = 'encounter.reasonCode.discharge.upgrade',
  Rehospitalized = 'encounter.reasonCode.discharge.rehospitalized',
}

export const encounterDischargeReasonCodeDisplay: Record<
  EncounterDischargeReasonCode,
  string
> = {
  [EncounterDischargeReasonCode.Completed]: 'Completed',
  [EncounterDischargeReasonCode.Demised]: 'Demised',
  [EncounterDischargeReasonCode.RevokeConsent]: 'Revoke Consent',
  [EncounterDischargeReasonCode.Transfer]: 'Transfer to other service provider',
  [EncounterDischargeReasonCode.Upgrade]: 'Upgrade to another service level',
  [EncounterDischargeReasonCode.Rehospitalized]:
    'Patient has been rehospitalized',
};

export enum EncounterPausedReasonCode {
  MIA = 'encounter.reasonCode.paused.mia',
  ReHospitalized = 'encounter.reasonCode.paused.rehospitalized',
  HAHUpgrade = 'encounter.reasonCode.paused.hahupgrade',
}

export const encounterPausedReasonCodeDisplay: Record<
  EncounterPausedReasonCode,
  string
> = {
  [EncounterPausedReasonCode.MIA]: 'Patient is missing in Action',
  [EncounterPausedReasonCode.ReHospitalized]:
    'Patient has been re-hospitalized',
  [EncounterPausedReasonCode.HAHUpgrade]: 'Patient has been upgraded to HAH',
};

export enum EncounterInvalidateReasonCode {
  RefusedConsent = 'encounter.reasonCode.invalidate.refusedconsent',
  EscalatedToHospital = 'encounter.reasonCode.invalidate.escalatedtohospital',
  RefusedCare = 'encounter.reasonCode.invalidate.refusedcare',
  DeclinedOnboarding = 'encounter.reasonCode.invalidate.declinedonboarding',
}

export const encounterInvalidateReasonCodeDisplay: Record<
  EncounterInvalidateReasonCode,
  string
> = {
  [EncounterInvalidateReasonCode.RefusedConsent]: 'Refused to give consent',
  [EncounterInvalidateReasonCode.EscalatedToHospital]: 'Escalated to hospital',
  [EncounterInvalidateReasonCode.RefusedCare]: 'Refused care',
  [EncounterInvalidateReasonCode.DeclinedOnboarding]: 'Declined onboarding',
};
